// Utilities
import axios from 'axios'


const state = {
 
  obj: 'working',
  new_document_object: {},
  error: '',
  
 
  margin: null
}

const mutations = {

  SET_NEW_DOCUMENT(state, payload) {

    state.new_document_object = payload
  },
  Auth_error(state, payload) {

    state.error = "Ce numéro de document n'existe pas"
    
  },
 
  
  
}

const actions = {

  getallusers({ commit }, Info) {
    
  
    const UserInfo = {
      
      role : Info.role,
     
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/getallusers', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },
  updatePassword({ commit }, Info) {
    
  
    const UserInfo = { 
    role : Info.role,
    password : Info.password,
    passwordConfirm : Info.passwordConfirm,
    email : Info.email
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/passwordupdate', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },
  updateusersubroles({ commit }, Info) {
    
  
    const UserInfo = { 
    role : Info.role,
    email : Info.email,
    subroles: Info.subroles
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/updateusersubroles', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },
 
  deleteuser({ commit }, Info) {
    
    
    const UserInfo = {
      
      role : Info.User.role,
      email: Info.email
     
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/deleteuser', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },
  
  createuser({ commit }, Info) {

    
    
    
    const UserInfo = {
      
      role : Info.role,
      name : Info.name,
      email: Info.email,
      password: Info.password,
      passwordConfirm: Info.passwordConfirm,
      createRole: Info.createRole,
      subroles: Info.subroles
     
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/createuser ', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },
  reAffect({ commit }, Info) {
  
    const UserInfo = { 
    role : Info.role,
    requestId : Info.requestId,
    }

    return new Promise((resolve, reject) => {
      axios( { url: '/api/6D679PEQP27YZ1H060TY/reAffect', method: 'POST', data: UserInfo, headers: { Authorization :  'Bearer ' + localStorage.getItem('token')} })
      .then(resp => {

      // commit('SET_NEW_DOCUMENT', resp.data)
      resolve(resp)
      }
      )
      .catch(err => {
        
        reject(err)
      })
    })

  },

  

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
